// src/app/core/http-header.interceptor.ts
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth-service';
import { StorageService } from '../services/storage-service';
import { LoadingService } from '../services/loading.service';
import { Router } from '@angular/router';



const API_BASE = environment.apiURL;

function isRefreshUrl(url: string) {
  return url.includes('/auth/refresh'); // ปรับให้ตรง endpoint จริง
}

export const httpHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const st = inject(StorageService);
  const auth = inject(AuthService);
  const router = inject(Router);
  const loading = inject(LoadingService);

  // 1) เติม base url
  let url = req.url;
  if (url.startsWith('/api/')) url = API_BASE + url;

  // 2) เติม headers
  let r = req.clone({ url });

  const appId = st.getAppId();
  if (appId) r = r.clone({ setHeaders: { 'www-app-id': appId } });

  const access = st.getAccessToken();
  if (access && !isRefreshUrl(r.url)) {
    r = r.clone({ setHeaders: { Authorization: `Bearer ${access}` } });
  }

  // 3) handle 401 -> refresh -> retry
  loading.increment();
  return next(r).pipe(
    finalize(() => loading.decrement()),
    catchError((err: any) => {
      if (!(err instanceof HttpErrorResponse)) return throwError(() => err);

      // ถ้าเป็น refresh เองแล้ว 401/400 ให้ปล่อยตก (กันลูป)
      if (isRefreshUrl(r.url)) return throwError(() => err);

      if (err.status === 401) {
        return auth.refreshAccessToken$().pipe(
          switchMap((newAccess) => {
            const retryReq = r.clone({
              setHeaders: { Authorization: `Bearer ${newAccess}` },
            });
            return next(retryReq);
          }),
          catchError((e) => throwError(() => e))
        );
      } 
      
      return throwError(() => err);
    })
  );
};
